<shared-modal [modalTitle]="selectTitle" [modalIcon]="selectIcon" [showFooter]="false">
  @if (items.length >= 5) {
    <div class="nav-item-menu-item select-list-item" modalHeader>
      <shared-search-input (searchValueChange)="applyFilter($event)" />
    </div>
  }

  <ng-container modalBody>
    @if (items) {
      <ul class="scroll-list" role="listbox" [attr.aria-label]="selectTitle">
        @for (item of items | appFilter: itemFilter : 'label'; track item.id; let idx = $index) {
          <li
            (click)="selectItem(item)"
            (keydown.enter)="selectItem(item)"
            (keydown.space)="selectItem(item)"
            class="select-item"
            role="option"
            [ngClass]="{ selected: isItemSelected(item.id) }"
            [tabindex]="idx"
            [attr.aria-selected]="isItemSelected(item.id)"
          >
            {{ item.label }}
          </li>
        }
      </ul>
    }
    @if (!items) {
      <div>
        <p>There are no items</p>
      </div>
    }
  </ng-container>
</shared-modal>
